import React from "react";

const Transactions = React.lazy(() => import("./orders"));
const TransactionDetail = React.lazy(() => import("./order-detail"));

export {
  Transactions,
  TransactionDetail,
};
